import { useCallback, useState } from "react";
import { AnalyticsParamsBag } from "./AnalyticsParamsBag.ts";
import { BusinessType } from "./BusinessType.tsx";
import { createAxiosInstance } from "../Axios/createAxiosInstance.ts";
import { MoneyTransferInfoDTO } from "./MoneyTransferInfoDTO.ts";

export function useCreateInvoicePaymentIntent() {
  const [loading, setLoading] = useState(false);

  const createInvoicePaymentIntent = useCallback(
    async ({
      email,
      firstName,
      lastName,
      priceId,
      productId,
      province,
      street,
      city,
      cap,
      pec,
      sdiCode,
      businessName,
      vat,
      businessType,
      taxCode,
      utmContent,
      utmCampaign,
      utmTerm,
      utmSource,
      utmMedium,
    }: {
      email: string;
      firstName: string;
      lastName: string;
      priceId: string;
      productId: string;
      businessType: BusinessType;
      taxCode: string;
      street: string;
      province: string;
      city: string;
      cap: string;
      pec?: string;
      sdiCode?: string;
      businessName?: string;
      vat?: string;
    } & AnalyticsParamsBag) => {
      try {
        setLoading(true);
        const { data } = await createAxiosInstance().post<MoneyTransferInfoDTO>(
          `/payment-intent/invoice`,
          {
            email,
            firstName,
            lastName,
            priceId,
            productId,
            utmTerm,
            utmSource,
            utmMedium,
            utmContent,
            utmCampaign,
            province,
            street,
            city,
            cap,
            pec,
            sdiCode,
            businessName,
            vat,
            businessType,
            taxCode,
          },
        );
        return data;
      } finally {
        setLoading(false);
      }
    },
    [],
  );
  return {
    createInvoicePaymentIntent,
    loading,
  };
}
